import type { RootState } from '../../../../configuration/setup/store';
import { isResourceBookable } from '../../common/utils/resourceUtil';
import { getAvailableResources } from '../resourceSelection/redux/resourceSelection.redux';

export function getNumberOfBookableResources(state: RootState) {
    return getAvailableResources(state).filter(isResourceBookable).length;
}
